<lb-application-container [navigationItems]="navigationItems()" [navDisabled]="isOnboardingRoute()">
	@if (accountLoaded()) {
		@if (noLearnerAvailable()) {
			<section class="no-learner">
				<h1>There is no learner to show here</h1>
				<p>
					This app shows a learner's own schedule, lessons and enrollments. Your account is not a learner and is
					not linked to one, so there is nothing for it to display.
				</p>
				<p>If you meant to view someone's account, start impersonation from their record in the admin app.</p>
				@if (adminAppUrl) {
					<a class="no-learner__action" [href]="adminAppUrl">Go to the admin app</a>
				}
			</section>
		} @else {
			<router-outlet></router-outlet>
		}
	}
</lb-application-container>
